// One motion vocabulary for the whole site, so every section enters with the
// same timing and easing instead of each page inventing its own.

// A soft deceleration curve — quick to start, long tail. Reads as "settling
// into place" rather than "sliding".
export const EASE = [0.22, 1, 0.36, 1];

// Shared viewport trigger. `once: true` keeps content still once you've read
// it; `amount` fires when a fifth of the element is showing.
export const viewport = { once: true, amount: 0.2 };

// Looser trigger for tall blocks that would otherwise never hit the threshold.
export const viewportTall = { once: true, amount: 0.1 };

export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: EASE } },
};

export const fadeDown = {
  hidden: { opacity: 0, y: -20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: EASE } },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.7, ease: EASE } },
};

export const slideInLeft = {
  hidden: { opacity: 0, x: -48 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.7, ease: EASE } },
};

export const slideInRight = {
  hidden: { opacity: 0, x: 48 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.7, ease: EASE } },
};

export const scaleIn = {
  hidden: { opacity: 0, scale: 0.92 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.55, ease: EASE } },
};

// The rule under every section title draws itself left-to-right.
export const drawRule = {
  hidden: { scaleX: 0 },
  visible: { scaleX: 1, transition: { duration: 0.8, ease: EASE } },
};

// Parent wrapper that releases its children one after another.
export const stagger = (staggerChildren = 0.09, delayChildren = 0) => ({
  hidden: {},
  visible: { transition: { staggerChildren, delayChildren } },
});

// Standard hover for a card: lift, no scale. Scaling a card in a grid closes
// the gap to its neighbours and reads as overlap.
export const cardHover = { y: -8, transition: { duration: 0.25, ease: EASE } };
